---
de:
  event_mapping:
    destroy_warning: Dies wird alle vorherigen Ereigniszuordnungen für diese Windturbine löschen. Sind Sie sicher, dass Sie fortfahren möchten?
    file_too_large: Die Datei ist zu groß
    import: Ereignisse-Zuordnung importieren
    invalid_file: Die Datei konnte nicht gelesen werden. Sie ist möglicherweise beschädigt oder im falschen Format.
    no_file_selected: Keine Datei ausgewählt
    title: Ereignisse-Zuordnung
    xlsx_file_input: Hochzuladende XLSX-Datei
